import React from 'react'
import clsx from 'clsx'
import { withI18next } from 'lib/i18n/withI18next'
import { hasLocizeTranslation } from 'lib/utils/locize'
import PropTypes from 'prop-types'
import Button from 'components/common/button'
import { BUTTON_TYPES } from 'constants/button'
import Typo from 'constants/typography'
import { PICKUP_LOCATION } from 'pages/pomelo-pickup/const'
import { handleStoreButtonClick } from 'components/pdp/interactions/find-this-item-at-store-cta/utils'

const FindThisItemAccordionDetails = ({ store, t }) => (
  <div className="accordion-details">
    <hr />
    <span className={Typo.subtitle2}>
      {hasLocizeTranslation(
        t,
        PICKUP_LOCATION.locationKey,
        PICKUP_LOCATION.location,
      )}
    </span>
    <span className={Typo.body2}>{store.address}</span>
    <Button
      type={BUTTON_TYPES.link}
      onClick={() =>
        handleStoreButtonClick(
          `https://maps.google.com/maps?daddr=${store.latitude},${store.longitude}`,
        )
      }
    >
      {hasLocizeTranslation(
        t,
        PICKUP_LOCATION.getDirectionKey,
        PICKUP_LOCATION.getDirection,
      )}
    </Button>
    <div className="accordion-details__contact">
      <span className={Typo.subtitle2}>
        {hasLocizeTranslation(
          t,
          PICKUP_LOCATION.contactKey,
          PICKUP_LOCATION.contact,
        )}
      </span>
      <Button
        className={clsx('button')}
        type={BUTTON_TYPES.link}
        onClick={() => handleStoreButtonClick(`tel:${store.contact_number}`)}
      >
        {store.contact_number}
      </Button>
    </div>
    <div className="accordion-details__store-hours">
      <span className={Typo.subtitle2}>
        {hasLocizeTranslation(
          t,
          PICKUP_LOCATION.hoursKey,
          PICKUP_LOCATION.hours,
        )}
      </span>
      {store.hours?.map((open_hour, index) => (
        <span key={index} className={Typo.body2}>
          {open_hour}
        </span>
      ))}
    </div>
  </div>
)

FindThisItemAccordionDetails.propTypes = {
  store: PropTypes.shape({
    address: PropTypes.string,
    contact_number: PropTypes.string,
    hours: PropTypes.arrayOf(PropTypes.string),
    latitude: PropTypes.number,
    longitude: PropTypes.number,
  }).isRequired,
  t: PropTypes.func.isRequired,
}

export default withI18next()(FindThisItemAccordionDetails)
